import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Divider, TextField, InputAdornment } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import arrowLeft from 'assets/images/arrowLeftBtn.svg';
import arrowRight from 'assets/images/arrowRightBtn.svg';
import { useResourcesStyles } from './styles';
import ResourcesList from './ResourcesList';

/**
 * Resource sidebar used in ScheduleV6.
 *
 * Split into:
 * - this container: handles search input and toggle/collapse;
 * - ResourcesList: heavy data/drag logic and rendering.
 *
 * Visual styling is kept equivalent to the legacy sidebar,
 * but implemented via a hook-based JSS API (makeStyles).
 */
const ResourceSidebar = ({ isShow = true, onChange, isAdminMobile = false }) => {
  const classes = useResourcesStyles();
  const [searchValue, setSearchValue] = useState('');
  const [isOpen, setIsOpen] = useState(isShow);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };
  
  useEffect(() => {
    if (onChange) onChange(isOpen);
  }, [isOpen, onChange]);

  const handleSearchChange = useCallback((e) => {
    setSearchValue(e.target.value);
  }, []);

  return (
    <aside
      className={classnames(
        isAdminMobile ? classes.mobileAdminRoot : classes.root,
        !isOpen && classes.rootHidden
      )}
    >
      <div className={classes.searchWrapper}>
        {!isAdminMobile && (
          <button type="button" className={classes.toggleButton} onClick={handleToggle}>
            {isOpen ? <img src={arrowLeft} alt="Hide resources" /> : <img src={arrowRight} alt="Show resources" />}
          </button>
        )}
        <TextField
          type="text"
          name="searchValue"
          variant="outlined"
          placeholder="Search"
          value={searchValue}
          onChange={handleSearchChange}
          className={classes.search}
          inputProps={{ 'aria-label': 'Search' }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <div className={classes.searchIcon}>
                  <SearchIcon />
                </div>
              </InputAdornment>
            ),
          }}
          fullWidth
        />
      </div>
      <Divider />
      <ResourcesList searchValue={searchValue} isAdminMobile={isAdminMobile} />
    </aside>
  );
};

ResourceSidebar.propTypes = {
  isShow: PropTypes.bool,
  onChange: PropTypes.func,
  isAdminMobile: PropTypes.bool,
};

export default ResourceSidebar;

